import gql from 'graphql-tag'

export const dataStatAgentomExcludesRegions = gql`
  query statAgentomExcludesRegions {
    statAgentomExcludesRegions: elements(
      where: { iblock: { code: { equals: "statAgentomExcludesRegions" } } }
    ) {
      name
      propertyValues {
        property {
          code
        }
        value
      }
    }
  }
`
